module.exports = __webpack_public_path__ + "static/media/FiraSans-Bold.a1acb00f.ttf";